/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import ErrorOutlineRounded from '@material-ui/icons/ErrorOutlineRounded';

import SnackbarCloseButton from './SnackbarCloseButton';

import {
  SnackbarProvider as NotistackProvider,
  SnackbarProviderProps,
} from 'notistack';

import styles from './styles';

type PropTypes = SnackbarProviderProps;

const SnackbarProvider: React.FC<PropTypes> = props => {
  return (
    <NotistackProvider
      css={styles}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      action={snackbarKey => <SnackbarCloseButton snackbarKey={snackbarKey} />}
      iconVariant={{
        info: <ErrorOutlineRounded style={{ marginRight: '10px' }} />,
        error: <ErrorOutlineRounded style={{ marginRight: '10px' }} />,
        success: <ErrorOutlineRounded style={{ marginRight: '10px' }} />,
        warning: <ErrorOutlineRounded style={{ marginRight: '10px' }} />,
      }}
      {...props}
    />
  );
};

export default SnackbarProvider;
